import React, { Fragment, useState } from "react"
import { Card } from "react-bootstrap"
import { CardBody, CardHeader } from "../../../../../_metronic/_partials/controls/index.js"
import { CardDetail, DetailText, NoteView } from "../../../../../component/index.jsx"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"

import { GoogleMap, Polygon, useLoadScript } from "@react-google-maps/api"
import { coordinateCenterPolygon, GoogleMapKey } from "../../../../helpers/MapHelper.js"
import { useTranslation } from "react-i18next"
import {
  stringFormatting,
  convertDotToComma,
  convertM2ToHectare,
  toCapitalize,
  toRupiah,
  getDueDateText
} from "../../../../helpers/TextHelper.js"
import {
  ACTIVITY_TYPE_ENUM,
  ACTIVITY_TYPE_STRING,
  BLOCK_ACTIVITY_TYPE_ENUM,
  DATE_TYPE_ENUM,
  LABELING_CONST,
  UNIT_STRING,
  isFrozen
} from "../../../../../constants/StringConstant.js"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import ModalInvoice from "../../../../../component/molecule/ModalInvoice/index.jsx"
import SVG from "react-inlinesvg"
import { getHSTUnit } from "../../../../helpers/StringCollection.js"
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers/AssetsHelpers.js"
import clsx from "clsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { isNumber } from "lodash"

export const AreaTab = ({
  titleCardDetail,
  descriptionLeft,
  descriptionRight,
  flatIconAndText2Rows,
  documentLahan,
  coordinate,
  detail,
  zoom,
  titleImage = null,
  withDocument = true,
  rejectReason,
  reason,
  reasonTitle = null,
  setIdDocument,
  mapAreas = [],
  status,
  loadingMap,
  setSelectedTab
}) => {
  const { isLoaded } = useLoadScript({
    // Enter your own Google Maps API key
    googleMapsApiKey: GoogleMapKey()
  })
  const { t } = useTranslation()

  const [showModalInvoice, setShowModalInvoice] = useState(false)

  const poligonStyle = {
    fillColor: "lightblue",
    fillOpacity: 0.7,
    strokeColor: "white",
    strokeOpacity: 0.6,
    strokeWeight: 1,
    clickable: false,
    draggable: false,
    editable: false,
    geodesic: false,
    zIndex: 1
  }

  // map
  const containerStyle = {
    width: "100%",
    height: "380px"
  }

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1 // optional, default to 1.
    }
  }

  const poligonStyleNew = (color) => {
    return {
      fillColor: "#" + color,
      fillOpacity: color === "FFFFFF" ? 0.5 : 0.7,
      strokeColor: "white",
      strokeOpacity: 1,
      strokeWeight: 0.4,
      clickable: false,
      draggable: false,
      editable: false,
      geodesic: false,
      zIndex: 1
    }
  }

  const activityIcon = (type) => {
    switch (type) {
      case ACTIVITY_TYPE_ENUM.PRELIMINARY:
        return ICON_CONSTANTS.PHASE.PHASE_PRELIMINARY
      case ACTIVITY_TYPE_ENUM.VEGETATIVE:
        return ICON_CONSTANTS.PHASE.PHASE_VEGETATIVE
      case ACTIVITY_TYPE_ENUM.FLOWERING:
        return ICON_CONSTANTS.PHASE.PHASE_FLOWERING
      case ACTIVITY_TYPE_ENUM.RIPE:
        return ICON_CONSTANTS.PHASE.PHASE_RIPE
      case ACTIVITY_TYPE_ENUM.HARVEST:
        return ICON_CONSTANTS.PHASE.PHASE_HARVEST
      default:
        return ICON_CONSTANTS.PHASE.PHASE_PRELIMINARY
    }
  }

  const renderMap = () => {
    return (
      <>
        {rejectReason && (
          <RowModule key={"card-rejectReason"}>
            <Card className={"reject-list-card"}>
              <CardHeader title={t("card_title_reason_of_rejection")} className="mb-0 pb-2" />
              <CardBody>
                {!rejectReason ? null : rejectReason?.length === 0 ? (
                  <span>{t("messages_response_reason_not_found")}</span>
                ) : (
                  <ul>
                    {rejectReason?.map((e, i) => (
                      <li key={i}>{e.enum_value}</li>
                    ))}
                  </ul>
                )}
              </CardBody>
            </Card>
          </RowModule>
        )}
        {reason && (
          <RowModule key={"card-reasonList"}>
            <Card className={"reason-list-card"}>
              <CardHeader title={reasonTitle} className="mb-0 pb-2" />
              <CardBody>
                {!reason ? null : Array.isArray(reason) && reason?.length > 0 ? (
                  <ul>
                    {reason?.map((e, i) => (
                      <li key={i}>{e.enum_value}</li>
                    ))}
                  </ul>
                ) : (
                  <ul>
                    <li>{reason}</li>
                  </ul>
                )}
              </CardBody>
            </Card>
          </RowModule>
        )}
        {detail?.area_status && isFrozen(detail?.area_status) && (
          <RowModule key={"card-freezeReason"}>
            <Card className="mb-4 warning-list-card">
              <Card.Header>
                <h4>{t("label_freeze_reason")}</h4>
              </Card.Header>
              <Card.Body>
                <div>{toCapitalize(stringFormatting(detail?.status_reason).toLowerCase())}</div>
              </Card.Body>
            </Card>
          </RowModule>
        )}
        {detail?.area_status && detail?.area_status === LABELING_CONST.BLACKLISTED && (
          <RowModule key={"card-blacklistReason"}>
            <Card className="mb-4 reject-list-card">
              <Card.Header>
                <h4>{t("label_blacklist_reason")}</h4>
              </Card.Header>
              <Card.Body>
                <div>{toCapitalize(stringFormatting(detail?.status_reason).toLowerCase())}</div>
              </Card.Body>
            </Card>
          </RowModule>
        )}
        <RowModule key={"card-list"}>
          <CardDetail
            titleCardDetail={titleCardDetail}
            descriptionLeft={descriptionLeft}
            descriptionRight={descriptionRight}
            flatIconAndText2Rows={flatIconAndText2Rows}
            titleImage={titleImage}
            kurBNI={detail?.has_kur}
            kurBNIImageurl={detail?.bank_image}
            headerWithoutLine={
              detail?.has_previous_outstanding && (
                <NoteView
                  icon={ICON_CONSTANTS.WARNING}
                  variant={"warning"}
                  customMarginClassName="mb-0"
                  titleClassName={"text-warning-D9913D"}
                  title={
                    <div className={"d-flex txt-14 px-8 justify-content-between"}>
                      {t("messages_alert_planting_season_unpaid")}
                    </div>
                  }
                  endContent={
                    <div
                      onClick={() => setSelectedTab(2)}
                      className={
                        "text-warning-D9913D txt-14 underline font-weight-bolder cursor-pointer"
                      }>
                      {t("label_see_more")}
                    </div>
                  }
                />
              )
            }
          />
        </RowModule>
        {detail?.block_information && detail?.block_information.is_seedling && (
          <RowModule key={"card-blockInformation"}>
            <Card className={"card-custom"}>
              <CardHeader title={t("label_seeding_block_information")} />
              <CardBody>
                {detail?.block_information?.block_activity && (
                  <div className="bg-neutral-light-gray rounded mb-6">
                    <div className="d-flex justify-content-between align-items-center px-8 py-4">
                      <div className="d-flex align-items-center" style={{ gap: 16 }}>
                        <span className="font-weight-bolder font-size-h6">
                          {t("label_qa_last_inspection")}
                        </span>
                        {detail?.block_information?.block_activity && (
                          <SVG
                            src={toAbsoluteUrl(
                              activityIcon(detail?.block_information?.block_activity)
                            )}
                            className="icon-sm"
                          />
                        )}
                        {detail?.block_information?.block_activity && (
                          <span>
                            {ACTIVITY_TYPE_STRING[detail?.block_information?.block_activity]}
                          </span>
                        )}
                        <span
                          className={clsx([
                            "font-weight-bolder",
                            detail?.block_information?.block_activity_status ===
                            BLOCK_ACTIVITY_TYPE_ENUM.PASS
                              ? "text-success"
                              : "",
                            detail?.block_information?.block_activity_status ===
                            BLOCK_ACTIVITY_TYPE_ENUM.NOT_PASS
                              ? "text-danger"
                              : "",
                            detail?.block_information?.block_activity_status ===
                            BLOCK_ACTIVITY_TYPE_ENUM.PARTIAL_PASS
                              ? "text-warning"
                              : ""
                          ])}>
                          {detail?.block_information?.block_activity_status &&
                          detail?.block_information?.block_activity_status ===
                            BLOCK_ACTIVITY_TYPE_ENUM.PASS
                            ? `(${t("label_pass")})`
                            : detail?.block_information?.block_activity_status ===
                              BLOCK_ACTIVITY_TYPE_ENUM.NOT_PASS
                            ? `(${t("label_not_pass")})`
                            : detail?.block_information?.block_activity_status ===
                              BLOCK_ACTIVITY_TYPE_ENUM.PARTIAL_PASS
                            ? `(${t("label_partial_pass")})`
                            : null}
                        </span>
                      </div>
                      <div>
                        {detail?.block_information?.land_area_pass ? (
                          <span>
                            {t("label_pass_area")}{" "}
                            {convertDotToComma(
                              convertM2ToHectare(detail?.block_information?.land_area_pass, 4),
                              UNIT_STRING.HA
                            )}
                          </span>
                        ) : (
                          <span>{t("label_pass_area")} - </span>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <table className="w-full">
                  <tbody>
                    <tr>
                      <td className="text-neutral-gray py-3" width={"7%"}>
                        {t("label_block_name")}
                      </td>
                      <td className="py-3" width={"18%"}>
                        {stringFormatting(detail?.block_information.block_name)}
                      </td>
                      <td className="text-neutral-gray py-3" width={"7%"}>
                        {t("label_file_number")}
                      </td>
                      <td className="py-3" width={"18%"}>
                        {stringFormatting(detail?.block_information.doc_number)}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-neutral-gray py-3" width={"7%"}>
                        {t("label_doc_number")}
                      </td>
                      <td className="py-3" width={"18%"}>
                        {stringFormatting(detail?.block_information.request_number)}
                      </td>
                      <td className="text-neutral-gray py-3" width={"7%"}>
                        {t("label_certification_number")}
                      </td>
                      <td className="py-3" width={"18%"}>
                        {stringFormatting(detail?.block_information.base_number)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CardBody>
            </Card>
          </RowModule>
        )}

        <RowModule key={"card-plantingSeason"}>
          <Card className={"card-custom"}>
            <CardHeader title={t("label_all_activity")} />
            <CardBody className="py-12">
              <div className="row" style={{ gap: 20 }}>
                <div className="col-3">{t("label_planting_season_total_invoice")}</div>
                <div className="col-8">{toRupiah(detail?.total_bill)}</div>
                <div className="col-3">{t("label_planting_season_paid_invoice")}</div>
                <div className="col-8">{toRupiah(detail?.paid_amount)}</div>
                <div className="col-3">{t("label_planting_season_unpaid_invoice")}</div>
                <div className="col-8">{toRupiah(detail?.remaining_bill)}</div>
                <div className="col-3">{t("label_planting_season_due_date")}</div>
                <div className="col-4">
                  {stringFormatting(
                    timeStampToDate(detail?.due_date, DATE_TYPE_ENUM.ISO_DATE_STRAP)
                  )}{" "}
                  {isNumber(detail?.days_until_due_date)
                    ? `(${stringFormatting(getDueDateText(detail?.days_until_due_date))})`
                    : ""}
                </div>
                <div className="col-4">
                  <div className="d-flex justify-content-end">
                    {detail?.has_debt && (
                      <div
                        onClick={() => setShowModalInvoice(true)}
                        className={
                          "text-primary-green txt-14 underline font-weight-bolder cursor-pointer"
                        }>
                        {t("button_see_detail")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className={"card-custom"}>
            <CardHeader title={t("label_planting_session")}>
              <div className="card-title d-flex align-items-center" style={{ gap: 12 }}>
                {detail?.is_hst && (
                  <>
                    <div>
                      {t("label_active")} ({getHSTUnit(detail?.hst)})
                    </div>
                    <div className="flag-green"></div>
                  </>
                )}
                {!detail?.is_hst && (
                  <>
                    <div>{t("label_inactive")}</div>
                    <div className="flag-inactive"></div>
                  </>
                )}
              </div>
            </CardHeader>
            <CardBody className="py-12">
              <div className="row" style={{ gap: 20 }}>
                <div className="col-3">{t("label_planting_planting_date")}</div>
                <div className="col-8">{stringFormatting(detail?.planting_date)}</div>
                <div className="col-3">{t("label_planting_season_harvest_date_estimation")}</div>
                <div className="col-8">{stringFormatting(detail?.harvest_date)}</div>
                <div className="col-3">{t("label_planting_season_plant_type")}</div>
                <div className="col-8">{`${stringFormatting(
                  detail?.plant_name
                )} /  ${stringFormatting(detail?.plant_varieties_name)}`}</div>
                <div className="col-3">{t("label_planting_season_package")}</div>
                <div className="col-8">{stringFormatting(detail?.package_name)}</div>
              </div>
            </CardBody>
          </Card>
        </RowModule>

        <RowModule key={"card-lokasiLahan"}>
          <Card className="card-custom">
            <CardHeader title={t("card_title_area_location").toUpperCase()} />
            <CardBody>
              {loadingMap ? (
                <div
                  className={"d-flex justify-content-center align-items-center"}
                  style={containerStyle}>
                  <div className="spinner spinner-primary" />
                </div>
              ) : (
                <Fragment googleMapsApiKey="AIzaSyDWuPp3biF_NddtL2Q7Zh5ewx4qERnUvkE">
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={coordinateCenterPolygon(coordinate)}
                    zoom={zoom}
                    mapTypeId={"hybrid"}>
                    {status === "active" || status === "pending" || status === "reject" ? (
                      status === "pending" && reason ? (
                        <Polygon paths={coordinate} options={poligonStyle} />
                      ) : (
                        mapAreas.map((place, index) => {
                          return (
                            <Polygon
                              key={index}
                              paths={place?.coordinates}
                              options={poligonStyleNew(place?.color)}
                            />
                          )
                        })
                      )
                    ) : (
                      <Polygon paths={coordinate} options={poligonStyle} />
                    )}
                  </GoogleMap>
                </Fragment>
              )}
            </CardBody>
          </Card>
          {withDocument && (
            <DetailText
              title={t("label_land_ownership_proof").toUpperCase()}
              type={"carousel"}
              value={documentLahan ? documentLahan.filter((item) => (item ? item : null)) : null}
              menu="AREA_DOCUMENT"
              responsiveCarousel={responsive}
              setIdDocument={setIdDocument}
            />
          )}
        </RowModule>

        <ModalInvoice show={showModalInvoice} setShow={setShowModalInvoice} data={detail} />
      </>
    )
  }

  return isLoaded ? renderMap() : null
}
